import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import pickMapImage       from '@/TokamapEditor/helpers/pickMapImage';
import { Shape }          from '@tokamap/core';

export default function replaceFeatureImage(shape: Shape, title = `Remplacer l'image`) {
	return pickMapImage(title, src => currentEditorStore.get?.setShapeImage(shape.id, { src }));
}
